import { DSSubscription, DSLabeledLink, LinkedLinkProps } from 'shared-definitions/types'
import { ApiRssLinkProps } from 'data-source/types.wp'

export interface SubscriptionLinkMapper {
  newsletterPageLinkBuilder: (slug: string) => LinkedLinkProps
}

export function subscriptionLinkMapper(
  input: Partial<ApiRssLinkProps>,
  opts: SubscriptionLinkMapper
): Pick<DSSubscription, 'button'> {
  let button: DSLabeledLink | null = null
  if (typeof input.rss_feed === 'string' && typeof input.rss_label === 'string') {
    button = {
      pLink: opts.newsletterPageLinkBuilder(input.rss_feed),
      label: input.rss_label,
    }
  }

  return { button }
}
